import {Prototype} from '../../../../decorators/Prototype';
import {NotificationsItemView} from '../NotificationsItemView/NotificationsItemView';

/**
 * @class NotificationsCollectionView
 * @extends Mn.CollectionView
 */
@Prototype({
    className: 'notifications-list',
    childView: NotificationsItemView,
})
export class NotificationsCollectionView extends Mn.CollectionView {

}


// WEBPACK FOOTER //
// ./shared/view/NavigationBarView/Notifications/NotificationsCollectionView/NotificationsCollectionView.js